import { getCroppedImageUrl } from '../CroppedImage';
import Head from 'next/head';

export default function FbHead(props: {
  shareUrl: string;
  shareItem: {
    title: string;
    description: string;
    share_img_url: string;
  };
  ogImageSquare?: [height: number, width: number];
}) {
  const { shareUrl, shareItem, ogImageSquare } = props;
  return (
    <Head>
      <meta
        property="fb:app_id"
        content={`${process.env.WEEE_FACEBOOK_APPID || process.env.NEXT_PUBLIC_WEEE_FACEBOOK_APPID}`}
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={shareUrl} />
      <meta property="og:title" content={shareItem?.title || 'Weee grocery'} />
      <meta property="og:description" content={shareItem?.description} />
      <meta property="og:image" content={shareItem?.share_img_url} />
      {/* <meta
        property="og:image"
        content={`${getCroppedImageUrl(shareItem?.share_img_url, {
          renderHeight: ogImageSquare ? ogImageSquare[0] : 600,
          renderWidth: ogImageSquare ? ogImageSquare[1] : 600,
          format: 'original',
          devicePixelRatio: 1
        })}`}
      /> */}
      <meta property="og:image:alt" content={shareItem?.title || 'Weee grocery'} />
      {ogImageSquare ? (
        <>
          <meta property="og:image:width" content={String([ogImageSquare[0]])} />
          <meta property="og:image:height" content={String([ogImageSquare[1]])} />
        </>
      ) : null}
    </Head>
  );
}
